import { CornerStyleValue, LengthStyleValue } from '../common/lobby/types';

const DIRECTIONS: (keyof Omit<CornerStyleValue, 'type'>)[] = [
  'topLeft',
  'topRight',
  'bottomLeft',
  'bottomRight',
];

export class CornerStyleValueService {
  private normalizeCornersStyleValue(styleValue: CornerStyleValue): string {
    const values: string[] = [];

    DIRECTIONS.forEach((direction) => {
      if (
        // @ts-expect-error - TODO: ds-types-bump
        styleValue[direction]?.type === 'Length' &&
        // @ts-expect-error - TODO: ds-types-bump
        styleValue[direction]?.value
      ) {
        // @ts-expect-error - TODO: ds-types-bump
        values.push(styleValue[direction]?.value + styleValue[direction]?.unit);
      }
    });

    return values.join(', ');
  }

  private normalizeLengthStyleValue(styleValue: LengthStyleValue): string {
    // @ts-expect-error - TODO: ds-types-bump
    return styleValue.value + styleValue.unit;
  }

  public normalize(styleValue: CornerStyleValue | LengthStyleValue): string {
    // @ts-expect-error - TODO: ds-types-bump
    if (styleValue.type === 'Corners') {
      return this.normalizeCornersStyleValue(styleValue);
    }

    return this.normalizeLengthStyleValue(styleValue);
  }

  public isEqual(
    styleValues: (CornerStyleValue | LengthStyleValue)[],
  ): boolean {
    if (!styleValues.length) {
      return false;
    }

    const firstNormalizedValue = this.normalize(styleValues[0]);

    return styleValues.every(
      (value) => this.normalize(value) === firstNormalizedValue,
    );
  }
}
